const styles = {
  innerBox: {
    mt: 6,
    mb: 12,
    padding: '20px',
  },
};

export default styles;
